export default __webpack_public_path__ + "static/media/p-14.daed8977.svg";